import React from 'react';
import { FilterState } from '../types/loan';
import { FilterIcon, SearchIcon } from 'lucide-react';
interface FilterControlsProps {
  filters: FilterState;
  onFilterChange: (filters: FilterState) => void;
  onApplyFilters: () => void;
}
export function FilterControls({
  filters,
  onFilterChange,
  onApplyFilters
}: FilterControlsProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    onFilterChange({
      ...filters,
      [name]: name === 'currentMarketRate' || name === 'rateThreshold' ? parseFloat(value) || 0 : value
    });
  };
  return <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 mb-6" data-id="element-104">
      <div className="flex items-center gap-2 mb-5" data-id="element-105">
        <FilterIcon className="w-5 h-5 text-violet-600" data-id="element-106" />
        <h2 className="text-lg font-semibold text-gray-800" data-id="element-107">
          Opportunity Filters
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[1fr_1fr_1.5fr_auto] gap-x-5 gap-y-4 items-end" data-id="element-108">
        <div data-id="element-109">
          <label htmlFor="currentMarketRate" className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-110">
            Current Market Rate (%)
          </label>
          <div className="relative" data-id="element-111">
            <input type="number" id="currentMarketRate" name="currentMarketRate" value={filters.currentMarketRate} onChange={handleChange} step="0.125" min="0" className="w-full pl-3 pr-10 h-[42px] border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-violet-500 outline-none transition-all" placeholder="e.g. 6.5" data-id="element-112" />
            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" data-id="element-113">
              <span className="text-gray-500 sm:text-sm" data-id="element-114">%</span>
            </div>
          </div>
        </div>

        <div data-id="element-115">
          <label htmlFor="rateThreshold" className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-116">
            Rate Threshold (Above Market)
          </label>
          <select id="rateThreshold" name="rateThreshold" value={filters.rateThreshold} onChange={handleChange} className="w-full pl-3 pr-10 h-[42px] border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-violet-500 outline-none transition-all bg-white" data-id="element-117">
            <option value="0.25" data-id="element-118">0.25%+</option>
            <option value="0.5" data-id="element-119">0.50%+</option>
            <option value="0.75" data-id="element-120">0.75%+</option>
            <option value="1.0" data-id="element-121">1.00%+</option>
            <option value="1.5" data-id="element-122">1.50%+</option>
            <option value="2.0" data-id="element-123">2.00%+</option>
          </select>
        </div>

        <div data-id="element-124">
          <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-125">
            Close Date Range
          </label>
          <div className="flex items-center gap-3" data-id="element-126">
            <input type="date" name="startDate" value={filters.startDate} onChange={handleChange} className="w-full px-3 h-[42px] border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-violet-500 outline-none transition-all text-sm" data-id="element-127" />
            <span className="text-xs font-medium text-gray-400 shrink-0" data-id="element-128">
              to
            </span>
            <input type="date" name="endDate" value={filters.endDate} onChange={handleChange} className="w-full px-3 h-[42px] border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-violet-500 outline-none transition-all text-sm" data-id="element-129" />
          </div>
        </div>
      </div>
    </div>;
}